import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { AdminReviews } from '../../components';

import css from './ListingPage.module.css';

const SectionReviews = props => {
  const { reviews } = props;

  return (
    <div className={css.sectionReviews}>
      <h2 className={css.reviewsHeading}>
        <FormattedMessage id="ListingPage.reviewsHeading" values={{ count: reviews.length }} />
      </h2>
      <AdminReviews reviews={reviews} />
    </div>
  );
};

export default SectionReviews;
